/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { Link } from 'react-router';

import useRouter from 'js/lib/useRouter';

import { Typography2 } from '@coursera/cds-core';

import TrackedDiv from 'bundles/page/components/TrackedDiv';

type Props = {
  name: string;
  target: string;
  isSelected?: boolean;
};

const styles = {
  default: () => css`
    list-style-type: none;
    margin: 0;
    padding: var(--cds-spacing-150) var(--cds-spacing-50) var(--cds-spacing-150) var(--cds-spacing-600);
    overflow: visible;
    border-left: 6px solid transparent;

    &:hover {
      background-color: var(--cds-color-neutral-background-primary);
      border-left-color: var(--cds-color-blue-50);
    }
  `,
  isSelected: () => css`
    font-weight: bold;
    background-color: var(--cds-color-neutral-background-primary);
    border-left-color: var(--cds-color-blue-700);

    &:hover {
      border-left-color: var(--cds-color-blue-700);
    }
  `,
};

const NavigationSubItem: React.FC<Props> = ({ name, target, isSelected }) => {
  const router = useRouter();

  return (
    <li css={{ cursor: 'pointer', position: 'relative' }}>
      <Link
        className="nostyle"
        to={{
          name: target,
          params: router.params,
          query: router.location.query,
        }}
      >
        <TrackedDiv
          trackClicks
          trackingName="navigation_item"
          data={{ entry: name }}
          css={[styles.default, isSelected && styles.isSelected]}
          data-e2e={`Tracked_Link~${name}`}
          data-pendo-guide={`MenuItem~${name}`}
        >
          <Typography2 component="p">{name}</Typography2>
        </TrackedDiv>
      </Link>
    </li>
  );
};

export default NavigationSubItem;
